import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/toaster";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Register from "./pages/Register";
import FAQ from "./pages/FAQ";
import Disclaimer from "./pages/Disclaimer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

import DevMapTest from "./pages/DevMapTest";

// Development-only diagnostic page. Requires BOTH conditions so it can never
// ship in production: NODE_ENV must be 'development' AND the explicit opt-in
// flag must be "true". With either condition false (including the flag unset
// or set to true in a production build), the route is not registered and the
// component is tree-shaken out of the bundle.
const devMapTestEnabled =
  process.env.NODE_ENV === "development" &&
  process.env.REACT_APP_ENABLE_DEV_MAP_TEST === "true";

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes with Header and Footer */}
            <Route path="/" element={
              <>
                <Header />
                <Home />
                <Footer />
              </>
            } />
            <Route path="/register" element={
              <>
                <Header />
                <Register />
                <Footer />
              </>
            } />
            <Route path="/faq" element={
              <>
                <Header />
                <FAQ />
                <Footer />
              </>
            } />
            <Route path="/disclaimer" element={
              <>
                <Header />
                <Disclaimer />
                <Footer />
              </>
            } />
            <Route path="/admin" element={
              <>
                <Header />
                <AdminLogin />
                <Footer />
              </>
            } />
            
            {/* Admin Dashboard without public header/footer */}
            <Route path="/admin/dashboard" element={<AdminDashboard />} />

            {/* DEVELOPMENT-ONLY diagnostic route — not part of the production app flow */}
            {devMapTestEnabled && (
              <Route path="/dev/map-test" element={<DevMapTest />} />
            )}
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </LanguageProvider>
  );
}

export default App;
